import { defineMessages } from 'react-intl';

const messages = defineMessages({
  pickListOptionsDescription: {
    description: 'Pick list print setup modal description',
    defaultMessage: 'Choose how your Pick Lists appear.',
    id: 'Du1kam',
  },
  summarizeByLabel: {
    description: 'Pick list summarize by',
    defaultMessage: 'Summarize By',
    id: 'O2YDfZ',
  },
  summarizeByBoth: {
    description: 'Pick List grouping summarize by name and sku',
    defaultMessage: 'SKU and Name',
    id: 'rca19+',
  },
  summarizeBySku: {
    description: 'Pick List grouping summarize by SKU',
    defaultMessage: 'SKU',
    id: 'rvPpcM',
  },
  summarizeByName: {
    description: 'Pick list grouping summarize by name',
    defaultMessage: 'Name',
    id: 'nbFIDU',
  },
  doNotSummarize: {
    description: 'Pick list grouping do not summarize',
    defaultMessage: 'Do not summarize items (list each item individually',
    id: '4hCdQ4',
  },
  orderItemsByLabel: {
    description: 'Pick list order items by',
    defaultMessage: 'Order Items By',
    id: 'xcKYjw',
  },
  orderItemsBySku: {
    description: 'Pick list sorting order by SKU',
    defaultMessage: 'SKU',
    id: 'RJVaIm',
  },
  orderItemsByName: {
    description: 'Pick list sorting order by name',
    defaultMessage: 'Name',
    id: 'Fu4Akx',
  },
  orderItemsByItems: {
    description: 'Pick list sorting order by item quantity',
    defaultMessage: 'Quantity',
    id: '3yHI6K',
  },
  orderItemsByWarehouse: {
    description: 'Pick list sorting order by warehouse location',
    defaultMessage: 'Warehouse Location',
    id: 'fv9kLh',
  },
  orderItemsByWarehouseThenSku: {
    description: 'Pick list sorting order by warehouse then sku',
    defaultMessage: 'Warehouse Location then SKU',
    id: 'rXVrxQ',
  },
  productImagesLabel: {
    description: 'Pick list product images label',
    defaultMessage: 'Product Images',
    id: 'kGVi2E',
  },
  printProductImages: {
    description: 'Pick list print product images option',
    defaultMessage: 'Print product images on Pick Lists',
    id: 'Ibm1dI',
  },
  orderNumberLabel: {
    description: 'Pick list order number label',
    defaultMessage: 'Order Number(s)',
    id: 'n+EUeR',
  },
  includeOrderNumber: {
    description: 'Pick list include order number option',
    defaultMessage: 'Include order numbers that contain each product',
    id: '/egc4s',
  },
  productSkuLabel: {
    description: 'Pick list product sku label',
    defaultMessage: 'Select SKU source',
    id: 'PVzBOj',
  },
  sellingChannelSku: {
    description: 'Pick list selling channel sku option',
    defaultMessage: 'Selling Channel',
    id: 's6FLR0',
  },
  shipstationProductCatalogSku: {
    description: 'Pick list shipstation product catalog sku option',
    defaultMessage: 'ShipStation Product Catalog',
    id: 'GeUCSz',
  },
  hideZeroQuantity: {
    description: 'Pick list option to hide items that have a quantity of 0',
    defaultMessage: 'Zero Quantity Items',
    id: '/KexoN',
  },
  useHideZeroQuantity: {
    description: 'Pick list title to use hide zero quantity items option',
    defaultMessage: 'Hide 0 quantity Items',
    id: 'YqUF0A',
  },
  inventoryCounts: {
    description: 'Pick list option to show inventory counts',
    defaultMessage: 'Inventory Counts',
    id: 'HMNRtS',
  },
  useInventoryCounts: {
    description: 'Pick list title to use inventory counts option',
    defaultMessage: 'Show “In Stock” count',
    id: 'WMo+qo',
  },
  shippingLocation: {
    description: 'Pick list shipping location option',
    defaultMessage: 'Use Shipping Location',
    id: 'MiPROK',
  },
  inventoryLocation: {
    description: 'Pick list inventory location option',
    defaultMessage: 'Use Inventory Location',
    id: 'Vio+tK',
  },
  warehouseLocation: {
    description: 'Pick list warehouse location',
    defaultMessage: 'Warehouse Location',
    id: 'Pik+iX',
  },
  includeLotId: {
    description: 'Checkbox to display the lot number on the pick list',
    defaultMessage: 'Include Lot ID',
    id: 'qBUKm0',
  },
  hideItemOptions: {
    description: 'Checkbox to hide item options on the pick list',
    defaultMessage: 'Hide Item Options',
    id: 'qF7XzR',
  },
});

export default messages;
